import sbiLogo from "assets/images/sbiLogo.png";

export const handleLogo = (logo:string) => {
    switch (logo) {
        case "SBI_LOGO":
          return sbiLogo
        default:
          return logo
      }
}